module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-num",
    attrs: {
      "id": "C1"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 1")]), _vm._v(" "), _c('p', {
    staticClass: "chap-title"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARKER")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNTY")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURTHOUSE")])]), _vm._v(" "), _c('p', {
    staticClass: "subhead1"
  }, [_vm._v("604 NORTH MAIN STREET")]), _vm._v(" "), _c('p', {
    staticClass: "subhead2"
  }, [_vm._v("817-598-6168")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Another town legend is that of the haunted courthouse. The 1884 building you see now is the fourth structure of Parker County limestone; it is located in its geographical center. It is in the middle of a fast-paced traffic circle with cars and trucks honking and whizzing by. This Second Empire–style courthouse is the heart of downtown and the entire community. The first courthouse was built in 1856 with lumber sourced over three hundred miles away. The second building was a larger two-story building and stood for nearly sixteen years until burning with most of the county records. The third try was built in 1879 but lasted only five years before being lost to yet another fire. On July 10, 1884, during the construction of this current building, a construction worker, Joseph Murray, fell to his death and is said to haunt it to this day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One of the most talked-about ghostly happenings at the Weatherford Courthouse is the mysterious figure often seen wandering the halls, described as a shadowy figure in old-fashioned attire. Witnesses have reported feeling a chill in the air when encountering this spectral presence. Some believe it to be the ghost of a former judge. As this courthouse has one of the largest courtrooms in the state, it served as a place of upholding justice until you were much farther into West Texas lands. Having had so many legal cases and people come through its doors, there could be any number of ghosts that visit or linger in this place. We are all made up of energy, and we leave residual amounts of it in places where we experience great joy and great sorrow. All these emotions, along with dread and fear, could be trapped in its walls and felt by visitors in its historic halls. The feeling so overcame one woman I spoke with that she was convinced something ominous began walking up the stairs behind her, moving closer to her side, and following her when she was in the building in the late 1990s. She went to a Catholic church to be blessed so the entity would not follow her home, and she was not even of that faith. Knowing this woman to be very stable and with a no-nonsense personality makes me believe her story without question. It still scares her to speak about it.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P16-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Weatherford Courthouse, 1950s. "), _c('i', [_vm._v("Postcard made for Corcanges Drug Store.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P16-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Postcard, 1960s. "), _c('i', [_vm._v("Stryker’s Western Fotocolor.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This structure underwent a major renovation in 2003, and the changes were met with more rumored hauntings and paranormal activity. Ghosts don’t like change, and activity is often reported as more frequent and sometimes more aggressive following renovations of any size. I believe spirits are trying to protect their space, not meaning any actual harm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Visitors have also reported hearing disembodied voices and footsteps echoing through the empty corridors, even when the building is closed to the public. Doors have been known to slam shut on their own, and lights flicker inexplicably, adding to the courthouse’s eerie atmosphere.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Keep your eyes peeled and your senses sharp; you never know when you might encounter one of the ghostly inhabitants who call this historic building home.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Texas Historical Marker on the building reads:")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("Scene of many noted trials. Built 1884–86. Cost $55,555.55. Fourth courthouse in history of county, organized 1856. An oak on Ft. Belknap Road was court site that year. In this building practiced S.W.T. Lanham, who was governor of Texas 1902–1906.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40a438f9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter1.vue
// module id = 72
// module chunks = 0